import { useEffect } from "react"
import { useOutletContext } from "react-router"
import { Graph } from "@/domains/visualization/components/Graph/Graph"
import {
  selectResetStore,
  selectRootCustomerId,
  selectSetRootCustomerId
} from "@/domains/visualization/store/selectors"
import { useGraphStore } from "@/domains/visualization/store/store"
import type { CustomerContext } from "../types/CustomerContext"

export function CustomerHierarchyPage() {
  const { customer } = useOutletContext<CustomerContext>()
  const currentRootId = useGraphStore(selectRootCustomerId)
  const resetStore = useGraphStore(selectResetStore)
  const setRootCustomerId = useGraphStore(selectSetRootCustomerId)

  useEffect(() => {
    if (currentRootId !== customer.id) {
      resetStore()
      setRootCustomerId(customer.id)
    }
  }, [customer.id, currentRootId, resetStore, setRootCustomerId])

  return <Graph />
}
